import GlobalStyle from './GlobalStyle';
import ClassNames from './ClassNames';
import colors from './colors';
import { GLOBAL_STYLE_VARIABLES } from './constants';
import depths from './depths';
import durations from './durations';
import { useMatchMedia } from './hooks';
import mediaQueries from './mediaQueries';
import spacings from './spacings';
import typography, { FONT_FAMILIES } from './typography';
import utils from './utils';

const theme = {
  colors,
  depths,
  durations,
  mq: mediaQueries,
  spacings,
  tp: typography,
  utils,
};

export {
  theme as default,
  GlobalStyle,
  ClassNames,
  GLOBAL_STYLE_VARIABLES,
  FONT_FAMILIES,
  useMatchMedia,
};
